export class SearchCondition {
  uploaded_at_from: string = ""
  uploaded_at_to: string = ""
  file_name: string = ""
  status: string = ""
  page: number = 1
  row_count: number =  20
}

export class WebupHistory{
  id: number
  uploaded_user_id: number
  uploaded_user_name: string
  uploaded_at: string
  file_name: string
  registered_user_id: number
  registered_user_name: string
  registered_at: string
  status: number
  error_msg: string
  file_count: number

  constructor(webupHistory: any){
    this.id = webupHistory.id;
    this.uploaded_user_id = webupHistory.uploaded_user_id;
    this.uploaded_user_name = webupHistory.uploaded_user_name;
    this.uploaded_at = webupHistory.uploaded_at;
    this.file_name = webupHistory.file_name;
    this.registered_user_id = webupHistory.registered_user_id;
    this.registered_user_name = webupHistory.registered_user_name;
    this.registered_at = webupHistory.registered_at;
    this.status = webupHistory.status;
    this.error_msg = webupHistory.error_msg;
    this.file_count = webupHistory.file_count;
  }
}

export enum WebupStatusEnum {
  ImageReading = "0",
  ImageReadError = "1",
  ImageReadCompleted = "2",
  DataRegistering = "3",
  DataRegistrationError = "4",
  DataRegistrationCompleted = "5",
  Deleted = "-1",
}

export enum WebupStatusNameEnum {
  ImageReading = "画像読込中",
  ImageReadError = "画像読込エラー",
  ImageReadCompleted = "画像読込完了",
  DataRegistering = "データ登録中",
  DataRegistrationError = "データ登録エラー",
  DataRegistrationCompleted = "完了",
  Deleted = "削除済",
}

export interface ComboboxWebupStatus {
  value: string
  text: string
}

export function GetComboboxWebupStatusArray() :ComboboxWebupStatus[]{
  const rtn: ComboboxWebupStatus[] = [];
  rtn.push({value: WebupStatusEnum.ImageReading, text: WebupStatusNameEnum.ImageReading});
  rtn.push({value: WebupStatusEnum.ImageReadError, text: WebupStatusNameEnum.ImageReadError});
  rtn.push({value: WebupStatusEnum.ImageReadCompleted, text: WebupStatusNameEnum.ImageReadCompleted});
  rtn.push({value: WebupStatusEnum.DataRegistering, text: WebupStatusNameEnum.DataRegistering});
  rtn.push({value: WebupStatusEnum.DataRegistrationError, text: WebupStatusNameEnum.DataRegistrationError});
  rtn.push({value: WebupStatusEnum.DataRegistrationCompleted, text: WebupStatusNameEnum.DataRegistrationCompleted});
  rtn.push({value: WebupStatusEnum.Deleted, text: WebupStatusNameEnum.Deleted});
  return rtn;
}